import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getSliderHeight,
  isSliderLayout,
  getChannelLayout,
} from 'shared/selectors/app-settings';

@connect(state => ({
  height: getSliderHeight(state),
  windowSize: state.windowSize,
  isSliderLayout: isSliderLayout(state),
  layout: getChannelLayout(state),
}))
export default class ForceSliderHeight extends React.Component {
  static propTypes = {
    height: PropTypes.number.isRequired,
    windowSize: PropTypes.object,
    children: PropTypes.node,
    isSliderLayout: PropTypes.bool,
    layout: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      height: null,
    };
  }

  componentWillReceiveProps({ height, isSliderLayout, layout, windowSize }) {
    const isHeightChanged = height !== this.props.height;
    const isNextSlider = isSliderLayout && layout !== this.props.layout;

    if (isNextSlider || isHeightChanged) {
      this.setState({ height });
    }

    if (windowSize.height === this.state.height) {
      this.setState({ height: null });
    }
  }

  render() {
    return React.cloneElement(this.props.children, {
      forcedHeight: this.state.height,
    });
  }
}
